import { Timestamp } from '@bufbuild/protobuf';
import {
  ImageWrapper,
  InfoDisplayPanel,
  NewSectionList,
  deserify,
  firstLetterImage,
  getDifficultyLevelString,
  getHumanReadableTimestampString,
  getLocalStorage,
  getMediaBasePath,
  pxToRem,
  pxTovW,
  useCommonServiceClientContext,
  theme,
  setLocalStorage,
  getEnvConfig,
  IClassAndSubjectSelected,
  AssessmentCard,
  ShimmerActiveHwCard,
  AssessmentTopicPopup,
  SectionListWithDotCarousel,
} from '@geneo2-web/shared-ui';
import { Box, Typography, useMediaQuery } from '@mui/material';
import { HomeworkTask } from '@protos/learning_management/lms.hw.common.apis_pb';
import { ProfileRolesEnum } from '@protos/user_management/ums.db_pb';
import { useEffect, useRef, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useAppDispatch, useAppSelector } from '../../../reduxStore/reduxHooks';
import {
  ASSESSMENT_CURRENT,
  HOMEWORK,
  HOMEWORK_COMPLETED,
  HOMEWORK_ONGOING,
} from '../../../routeHandling/RoutesNomenclature';
import { getSubjectsMap } from '../../../utils/icons';
import { interactionEvent } from '../../Auth/auth.events';
import {
  resetCreatedAssessmentStatus,
  resetSelectedTasksInfo,
  setCreatedAssessmentStatus,
  setFetchedAssessmentDetails,
  setModuleFilteredQuestions,
  setSelectedTasksInfo,
} from '../../Assessment/reducer/assessmentFlow.slice';
import {
  setAssessmentListData,
  setSelectedAssessmentId,
} from '../../ManageHomework/reducer/manageHomework.slice';
import SectionListSckeleton, { HomeworkListShimmer } from '../shimmer';
import { useDownloadContext } from '../../../app/Context/DownloadContextProviderV2';
import {
  AssessmentEnum,
  AssignmentConfigEnum,
  ModeOfConductionEnum,
} from '@protos/learning_management/lms.db_pb';
import { AssessmentListEnum } from '@protos/learning_management/lms.assessment.student.apis_pb';
// import {  } from '../reducer/homeDashboard.slice';

import {
  setTeacherCompletedHwList,
  setTeacherHwList,
} from '../reducer/homeDashboard.slice';
import { AssessmentTask } from '@protos/learning_management/lms.assessment.common.apis_pb';
import { convertToSequenceInfo } from '../../Assessment/Common/ReviewAssessment/functions';
import { getSubjectListForAssessmentCard } from '../../Assessment/utils/assessment.utils';
interface IProps {
  seeAllClickHandler: () => void;

  loading?: boolean;
  error?: boolean;
  dataId?: string;
}
export default function HomeCompletedHomeworkList(props: IProps) {
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const isIpad = useMediaQuery(theme.breakpoints.down('lg'));
  const { seeAllClickHandler, loading, error, dataId = 'completed_assessments_see_all' } = props;
  const navigate = useNavigate();
  const { isOffline } = useDownloadContext();
  const maxItemsToShow = 20;
  // const [homeworkList, setHomeworkList] = useState<HomeworkTask[]>([]);
  const dispatch = useAppDispatch();
  const config = getEnvConfig();
  const prevClassSubjectInfo = useRef<IClassAndSubjectSelected | undefined>(
    undefined
  );
  const isFirstRender = useRef(false); // Tracks if it's the initial render
  const location = useLocation();
  const teacher_profile_id = getLocalStorage('userId');
  const { user_info } = deserify(useAppSelector((state) => state.auth));
  const { assessment_list_data } = useAppSelector(
    (state) => state.manageHomework
  );
  const { class_subject_info, teacher_completed_hw_list } = deserify(
    useAppSelector((state) => state.homeDashboard)
  );
  const width = window.innerWidth;
  const isIpadOnly = !isMobile && isIpad;
  const [selectedHomework, setSelectedHomework] = useState<
    AssessmentTask | undefined
  >();
  const [chapterListPopup, setChapterListPopup] = useState(false);
  const {
    LmsHomewokTeacherAPIServiceV1ClientWithStatusCodeHandler,
    LmsHomeworkCommonAPIServiceV1ClientWithStatusCodeHandler,
    LmsAssessmentTeacherAPIServiceV1WithStatusCodeHandler,
    LmsAssessmentCommonAPIServiceV1ClientWithStatusCodeHandler,
  } = useCommonServiceClientContext();

  const subMap = getSubjectsMap();

  useEffect(() => {
    dispatch(resetSelectedTasksInfo());
    dispatch(resetCreatedAssessmentStatus());
  }, []);

  // useEffect(() => {
  //   if (!isFirstRender.current) {
  //     // Skip the first render
  //     isFirstRender.current = true;
  //     prevClassSubjectInfo.current = class_subject_info; // Initialize the ref
  //     return;
  //   }

  //   // Convert objects to strings for deep comparison
  //   const prevValueString = JSON.stringify(prevClassSubjectInfo.current);
  //   const currentValueString = JSON.stringify(class_subject_info);
  //   if (prevValueString !== currentValueString) {
  //     getTeacherLessonList(teacher_profile_id);
  //   }

  //   // Update the ref to the current value
  //   prevClassSubjectInfo.current = class_subject_info;
  // }, [class_subject_info]);
  const ChapterListPopupHandler = (assessment: AssessmentTask) => {
    setSelectedHomework(assessment);
    setChapterListPopup(true);
  };

  const cardClickHandler = async (
    hw: AssessmentTask
    // homeworkId: bigint,
    // homeworkTargetDate?: Timestamp,
    // moduleId?: number
  ) => {
    const {
      assessmentId: homeworkId,
      assessmentTargetDate: homeworkTargetDate,
      moduleId,
    } = hw;
    if (!homeworkTargetDate && moduleId) {
      getHomeworkDetails(homeworkId, moduleId.toString());
      return;
    }
    if (!homeworkTargetDate) return;

    await interactionEvent({
      url: 'Teacher_Home',
      context: 'Homeworks',
      name: 'HOMEWORK_OPEN',
      isOffline: isOffline,
    });

    const time = new Timestamp(homeworkTargetDate).toDate();
    const isEnded = hasTimePassed(time.getTime().toString());
    switch (isEnded) {
      case false:
        dispatch(setSelectedAssessmentId(homeworkId));
        if (
          hw.modeOfConduction ===
          ModeOfConductionEnum.MODE_OF_CONDUCTION_GENEO_CLICKER
        ) {
          navigate('/clicker-assessment-manage', {
            state: {
              from: location.pathname,
            },
          });
        } else {
          // Live Quiz mode falls through here too — OngoingHomework itself
          // special-cases MODE_OF_CONDUCTION_WEB_LIVE (same as it already
          // does for OMR) rather than this routing to a dedicated page.
          navigate(HOMEWORK_ONGOING);
        }
        break;
      case true:
        dispatch(setSelectedAssessmentId(homeworkId));
        if (
          hw.modeOfConduction ===
          ModeOfConductionEnum.MODE_OF_CONDUCTION_GENEO_CLICKER
        ) {
          navigate('/clicker-assessment-manage', {
            state: {
              from: location.pathname,
            },
          });
        } else {
          navigate(HOMEWORK_COMPLETED);
        }
        break;
      default:
        break;
    }
  };

  const getHomeworkDetails = async (homeworkId: bigint, moduleId: string) => {
    try {
      const response =
        await LmsAssessmentCommonAPIServiceV1ClientWithStatusCodeHandler.fetchAssessmentContent(
          {
            personId: teacher_profile_id,
            personType: ProfileRolesEnum.PROFILE_ROLE_TEACHER,
            assessmentId: homeworkId,
          }
        );
      if (response.data) {
        const HwData = response.data;
        dispatch(
          setCreatedAssessmentStatus(HwData.assessment?.taskCreationStatus)
        );
        dispatch(
          setModuleFilteredQuestions({ questions: HwData.assessmentContent })
        );
        dispatch(setFetchedAssessmentDetails(HwData.assessment));
        const sequenceInfo = convertToSequenceInfo(
          HwData.questionsSequenceInfo
        );
        if (sequenceInfo) {
          dispatch(setSelectedTasksInfo(sequenceInfo));
        }
        navigate(`${HOMEWORK}${ASSESSMENT_CURRENT}/${moduleId}`);
      }
    } catch (err) {
      console.log(err);
    }
  };
  function hasTimePassed(milliseconds: string) {
    const currentTime = new Date().getTime();
    const targetTime = Number(milliseconds);
    return targetTime <= currentTime;
  }

  return loading === true ? (
    <HomeworkListShimmer children={ActiveHwShimmerArray} />
  ) : (
    <Box>
      <SectionListWithDotCarousel
        noContentMessage="No Assessments for Today"
        isError={error}
        containerMdWidth="1214"
        itemsToShow={isMobile ? 1 : 3}
        title="Completed Assessments"
        linkButtonHandler={seeAllClickHandler}
        linkButtonText="See All"
        linkButtonDataId={dataId}
        titleDataId="completed_assessments_title"
        countDataId="completed_assessments_count"
        totalNoOfItems={assessment_list_data?.assesmentListInfo?.endedCount}
        maxItemsToShow={maxItemsToShow}
        items={teacher_completed_hw_list?.slice(0, maxItemsToShow).map((hw) => (
          // <InfoDisplayPanel
          //   defaultImage="homework-v1"
          //   image={getMediaBasePath(
          //     hw.assessmentPosterImgUrl,
          //     'processedMediaBucket'
          //   )}
          //   cardClickHandler={() =>
          //     cardClickHandler(
          //       hw.assessmentId,
          //       new Timestamp(hw.assessmentTargetDate),
          //       hw.moduleId
          //     )
          //   }
          //   variant={!isMobile && isIpad ? 'large' : 'small'}
          //   submissionType={hw.submissionType}
          //   blueSubText={`${hw.class}${hw.section} - ${hw.subject}`}
          //   mainHeading={hw.assessmentTitle}
          //   iconDetails={[
          //     { iconName: 'clock', text: `${hw.estimatedTimeInMin} mins` },
          //     {
          //       iconName: 'questions',
          //       text: `${hw.assessmentContentInfo?.numberOfQuestions}`,
          //     },
          //     {
          //       iconName: 'bar-graph',
          //       text: `${getDifficultyLevelString(hw.difficultyLevel)}`,
          //     },
          //   ]}
          //   status={<LessonPlanInfoPanelStatus lesson={hw} />}
          // />
          <AssessmentCard
            homework={hw}
            assessCardType="Ended"
            chapterListPopupHandler={ChapterListPopupHandler}
            modeofConduction={hw.modeOfConduction}
            onClick={() => cardClickHandler(hw)}
            rootStyles={{
              width: { xs: pxToRem(320), md: pxTovW(590), lg: pxTovW(464) },
            }}
            proctoring={
              hw.assignmentInfo?.find(
                (info) =>
                  info.configName ===
                  AssignmentConfigEnum.ASSIGNMENT_CONFIG_PROCTORING
              )?.isEnabled
                ? true
                : false
            }
            subjectList={getSubjectListForAssessmentCard(
              hw,
              user_info?.teachClassSubjects
            )}
            dataId="completed_assessment_card"
          />
        ))}
      />
      <AssessmentTopicPopup
        assessment={selectedHomework}
        open={chapterListPopup}
        handleClose={() => setChapterListPopup(false)}
      />
    </Box>
  );
}
const ActiveHwShimmerArray = [
  <ShimmerActiveHwCard key={1} variant="large" />,
  <ShimmerActiveHwCard key={2} variant="large" />,
];
interface InfoDisplayPanelStatus {
  lesson: AssessmentTask;
}
const LessonPlanInfoPanelStatus = ({ lesson }: InfoDisplayPanelStatus) => {
  // const taughtTime = getHumanReadableTimestampString(
  //   lesson.lastSessionTime
  // )?.split(' ');
  const { user_info } = deserify(useAppSelector((state) => state.auth));
  const editTime = getHumanReadableTimestampString(
    lesson.lastModifiedTime
  )?.split(' ');

  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        borderTop: `${pxTovW(2)} solid #E7E7E7D9`,
        pt: { xs: pxToRem(5), md: pxTovW(5) },
        width: '100%',
      }}
    >
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          gap: { xs: pxToRem(5), md: pxTovW(5) },
        }}
      >
        <ImageWrapper
          name="geneo-blue"
          type="png"
          parentFolder="icons"
          styles={{
            width: { xs: pxToRem(18), md: pxTovW(28) },
            height: { xs: pxToRem(18), md: pxTovW(28) },
            borderRadius: '50%',
          }}
          path={
            getMediaBasePath(lesson.teacherProfileImageUrl) ||
            firstLetterImage(lesson.teacherName) ||
            firstLetterImage('Geneo')
          }
        />
        <Typography variant="smallText" fontWeight="bold">
          {user_info?.teacherProfileId.toString() ===
          lesson?.teacherId?.toString()
            ? 'You'
            : lesson.teacherName || 'Geneo'}
        </Typography>
      </Box>

      {lesson.teacherName && (
        <Typography variant="subText" color="text.disabled">
          {editTime && Number(editTime[0]) < 2
            ? 'Recently Edited'
            : 'Edited ' + editTime?.join(' ')}
        </Typography>
      )}
    </Box>
  );
};
